"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebviewProvider = void 0;
const types_1 = require("../types");
const WebviewTransport_1 = __importDefault(require("../WebviewTransport"));
const sdk_core_1 = require("@multiversx/sdk-core");
const webview_1 = require("../utils/webview");
class WebviewProvider {
    constructor(eventBus) {
        this.eventBus = eventBus;
        this.token = null;
        this.webviewNetwork = new WebviewTransport_1.default();
        this.address = null;
        this.signature = null;
    }
    getAddress() {
        return this.address;
    }
    getBaseProvider() {
    }
    getSignature() {
        return this.signature;
    }
    getType() {
        return types_1.AuthProviderType.WEBVIEW;
    }
    init() {
        if (window !== undefined) {
            const params = new URLSearchParams(window.location.search);
            const token = params.get("accessToken");
            if (!token) {
                return Promise.resolve(false);
            }
            this.doLogin(token);
            return Promise.resolve(true);
        }
        return Promise.resolve(false);
    }
    login(token) {
        return __awaiter(this, void 0, void 0, function* () {
            const getAccessToken = () => new Promise((resolve, reject) => {
                this.webviewNetwork.on(types_1.WebViewProviderResponseEnums.loginResponse, (message) => {
                    const { accessToken, error } = message;
                    if (error) {
                        reject(error);
                    }
                    else {
                        resolve(accessToken);
                    }
                });
            });
            this.webviewNetwork.post(types_1.WebViewProviderRequestEnums.loginRequest);
            try {
                const accessToken = yield getAccessToken();
                return this.doLogin(accessToken);
            }
            catch (e) {
                console.error(e);
                throw e;
            }
            finally {
                this.webviewNetwork.off(types_1.WebViewProviderResponseEnums.loginResponse);
            }
        });
    }
    doLogin(accessToken) {
        if (!accessToken) {
            return "";
        }
        this.token = accessToken;
        const _token = (0, webview_1.decodeAuthToken)(accessToken);
        if (!_token) {
            return "";
        }
        const { signature, address } = _token;
        this.address = address;
        this.signature = signature;
        this.eventBus.emit("login", {});
        return address;
    }
    logout() {
        this.webviewNetwork.post(types_1.WebViewProviderRequestEnums.logoutRequest);
        this.token = null;
        this.address = null;
        this.signature = null;
        this.eventBus.emit("logout", {});
        return Promise.resolve(true);
    }
    on(event, handler) {
        this.eventBus.subscribe(event, handler);
    }
    off(event, handler) {
        this.eventBus.unsubscribe(event, handler);
    }
    signTransaction(tx) {
        return __awaiter(this, void 0, void 0, function* () {
            const txs = yield this.signTransactions([tx]);
            return txs[0];
        });
    }
    signTransactions(transactions) {
        return __awaiter(this, void 0, void 0, function* () {
            const signTxs = () => new Promise((resolve, reject) => {
                window.transactionsSigned = (txs, error) => {
                    if (error) {
                        reject(error);
                        window.transactionsSigned = null;
                        return;
                    }
                    const signedTxs = JSON.parse(txs);
                    resolve(signedTxs.map((tx) => sdk_core_1.Transaction.fromPlainObject(tx)));
                    window.transactionsSigned = null;
                };
                this.webviewNetwork.on(types_1.WebViewProviderResponseEnums.signTransactionsResponse, (message) => {
                    const { transactions, error } = message;
                    if (error) {
                        reject(error);
                    }
                    else {
                        resolve(transactions.map((tx) => sdk_core_1.Transaction.fromPlainObject(tx)));
                    }
                });
            });
            try {
                this.webviewNetwork.post(types_1.WebViewProviderRequestEnums.signTransactionsRequest, transactions.map((tx) => tx.toPlainObject()));
                return yield signTxs();
            }
            catch (e) {
                throw e;
            }
            finally {
                this.webviewNetwork.off(types_1.WebViewProviderResponseEnums.signTransactionsResponse);
            }
        });
    }
    toJson() {
        return {
            address: this.address,
            authenticated: !!this.address,
            authProviderType: this.getType(),
        };
    }
}
exports.WebviewProvider = WebviewProvider;
